// Styles
import styled from 'styled-components/macro'

// Core
import React from 'react'

// Components, services, constants

// 3rd party
import classnames from 'classnames'

type Props = {
  className?: string
}

const OrderCardPlaceholder = ({className}: Props) => {
  return <OrderCardPlaceholder.Styled className={classnames('order-card-placeholder', className)} />
}

OrderCardPlaceholder.Styled = styled.div`
  background: ${({theme}) => theme.colors.stone.light};
  opacity: 0.5;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  height: 236px;
  width: 308px;
`

export default OrderCardPlaceholder
